import * as yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const commentDialogSchema = yup.object({
  category: yup.string().required('Campo requerido'),
  comment: yup.string().trim().required('Campo requerido'),
});
